import axios from "axios";
const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    // const token = store.getState().user.token;
    // const refreshToken = store.getState().user.refreshToken;
    const token = localStorage.getItem('x-api-key')
    // const refreshToken = localStorage.getItem('aenx-renew-token')
    if (!config.headers) {
      config.headers = {};
    }
    if (token) {
      config.headers["X-Api-Key"] = token ? token : "";
      // config.headers["aenx-renew-token"] = refreshToken ? refreshToken : "";
    }
    // config.headers["request-app-name"] = "aenconnect";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default instance;
